import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessageModel } from '../models/message-model';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  constructor() { }

  sendMessage: BehaviorSubject<MessageModel> = new BehaviorSubject(new MessageModel());

  // Metadata Property Type
  md_property_type_date = 'Date';
  md_property_type_string = 'String';

  results_view_summary = "summary";
  results_view_table = "table";

  property_operator_all = "all";
  property_operator_any = "any";
  // property_form_array_prefix = "prop_";

  date_operator_between = 'between';
  date_operator_equals = 'equals';
  date_operator_less = 'ends';
  date_operator_greater = 'starts';

  text_operator_starts = "starts";
  text_operator_starts_not = "notstarts";
  text_operator_contains = "contains";
  text_operator_contains_not= "notcontains";
  text_operator_equals = "equals";
  text_operator_equals_not = "notequals";

  azSuggester = "sg";

  public api_base = environment.api_host + 'api/';

  // Metadata properties API
  public api_metadata = this.api_base + 'metadata';

  public api_appSettings = this.api_base + 'appsetting';

  public api_announcements = this.api_base + 'msgs';

  // Profile API
  public api_user_profile = this.api_base + 'userprofile';

  // Profile API
  public api_saved_search = this.api_base + 'usersearch';

  // Search Query API
  public api_azsearch = this.api_base + 'search';
  public api_azsearch_suggest = this.api_azsearch + '/suggest';
  public api_azsearch_suggest_facet = this.api_azsearch + '/suggest/facet';
  public api_azsearch_autocomplete = this.api_azsearch + '/autocomplete';
  public api_azsearch_document = this.api_azsearch + "/docdetails";
  public api_azsearch_download = this.api_azsearch + "/download";
  public api_az_zip = this.api_base + 'zip';

  // Test API.
  public api_me = this.api_base + 'me';
}
